/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  useGetNotificationGroupsQuery,
  NotificationGroupSortInput,
} from "~/generated/graphql";
import { isEmpty } from "~/tools";

type Props = {
  page: string;
  limit: string;
  sort: NotificationGroupSortInput;
};

export function useGetNotificationGroups({ page, limit, sort }: Props) {
  const {
    data: notificationGroupData,
    loading,
    error,
  } = useGetNotificationGroupsQuery({
    variables: { page: Number(page), limit: Number(limit), sort },
  });

  const data = notificationGroupData?.notificationGroups?.result ?? [];
  const count = notificationGroupData?.notificationGroups.pageInfo?.count ?? 0;
  const noData = isEmpty(data);

  return {
    data,
    loading,
    error,
    count,
    noData,
  } as const;
}
